import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ImpersonationService } from './impersonation.service';

const ALL_ROLES = [
    'app_admin',
    'app_editor',
    'app_user',
    'app_user_beta',
    'app_free_trial',
    'app_subscriber',
    'app_subscriber_annual',
    'app_analytics'
];

@Component({
    standalone: true,
    selector: 'abs-impersonation-page',
    imports: [CommonModule, IonicModule, FormsModule],
    template: `
        <ion-header>
            <ion-toolbar>
                <ion-title>Role Impersonation</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <p>
                Select roles to impersonate. These roles will be merged with your real roles for this session. This lets you test the app as
                if you had different access levels.
            </p>

            <ion-list>
                @for (role of allRoles; track role) {
                    <ion-item>
                        <ion-checkbox
                            [checked]="selectedRoles().includes(role)"
                            (ionChange)="toggleRole(role, $event)"
                            justify="start"
                            labelPlacement="end"
                        >
                            {{ role }}
                        </ion-checkbox>
                    </ion-item>
                }
            </ion-list>

            <div class="actions">
                <ion-button (click)="apply()" [disabled]="selectedRoles().length === 0"> Apply Roles </ion-button>
                <ion-button color="medium" (click)="stop()" [disabled]="!impersonationService.isImpersonating()">
                    Stop Impersonation
                </ion-button>
            </div>
        </ion-content>
    `,
    styles: [
        `
            .actions {
                display: flex;
                gap: 8px;
                margin-top: 16px;
            }
        `
    ]
})
export class ImpersonationPage {
    impersonationService = inject(ImpersonationService);
    allRoles = ALL_ROLES;
    selectedRoles = signal<string[]>([...this.impersonationService.currentImpersonatedRoles()]);

    toggleRole(role: string, event: any) {
        const checked = event.detail.checked;
        const current = this.selectedRoles();
        if (checked && !current.includes(role)) {
            this.selectedRoles.set([...current, role]);
        } else if (!checked) {
            this.selectedRoles.set(current.filter((r) => r !== role));
        }
    }

    apply() {
        this.impersonationService.startImpersonation(this.selectedRoles());
    }

    stop() {
        this.impersonationService.stopImpersonation();
        this.selectedRoles.set([]);
    }
}
